import {
  useState, useCallback, Dispatch, SetStateAction,
} from 'react';

interface MediaDialogState {
  open: boolean;
  img: string;
  date: string;
  petName: string;
}

interface UseMediaDialogReturn {
  dialogState: MediaDialogState;
  openMediaDialog: (img: string, date: string, petName: string) => void;
  closeMediaDialog: () => void;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}

function useMediaDialog(): UseMediaDialogReturn {
  const [dialogState, setDialogState] = useState<MediaDialogState>({
    open: false,
    img: '',
    date: '',
    petName: '',
  });

  const openMediaDialog = useCallback((img: string, date: string, petName: string) => {
    setDialogState({
      open: true,
      img,
      date,
      petName,
    });
  }, []);

  const closeMediaDialog = useCallback(() => {
    setDialogState((prev) => ({ ...prev, open: false }));
  }, []);

  const setDialogOpen: Dispatch<SetStateAction<boolean>> = useCallback((value) => {
    setDialogState((prev) => ({
      ...prev,
      open: typeof value === 'function' ? value(prev.open) : value,
    }));
  }, []);

  return {
    dialogState,
    openMediaDialog,
    closeMediaDialog,
    setDialogOpen,
  };
}

export default useMediaDialog;
